import React from 'react'

export default () => <h1>Reports</h1>
